/* Slick */
$('.product-info .variants-list').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  appendDots: $('.slick-dots-container'), // Append dots into scrollable container (Modified by A&C)
  prevArrow: "<button type='button' class='slick-prev pull-left'><i class='icon-angle-left'></i></button>",
  nextArrow: "<button type='button' class='slick-next pull-right'><i class='icon-angle-right'></i></button>"       
});
$(document).ready(function() {
  setTimeout(function() {
    $('.product-card').each(function() {
      const variantsList = $(this).find('.variants-list');
      if (variantsList.length) {
        variantsList.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
          appendDots: $(this).find('.slick-dots-container'),
          prevArrow: "<button type='button' class='slick-prev pull-left'><i class='icon-angle-left'></i></button>",
          nextArrow: "<button type='button' class='slick-next pull-right'><i class='icon-angle-right'></i></button>"
        });
      }
    });
  }, 1000); // Adjust delay if necessary
});
$('.variants-list').on('afterChange', function(event, slick, currentSlide) {
  var activeDot = $('.slick-dots li.slick-active');
  var dotsContainer = $('.slick-dots-container');

  // Scroll the dots container to bring the active dot into view
  var offset = activeDot.offset().left - dotsContainer.offset().left;
  var containerWidth = dotsContainer.width();

  // Scroll if the active dot is not fully in view
  if (offset < 0 || offset > containerWidth - activeDot.outerWidth()) {
    dotsContainer.animate({
      scrollLeft: dotsContainer.scrollLeft() + offset - containerWidth / 2
    }, 500);
  }
});
/* Misc - Product card */
$(document).ready(function() {
  $('.product-card__figure').hover(
    function() {
      // Show sizes on hover
      $(this).find('.product-sizes').fadeIn(200);
    },
    function() {
      // Hide sizes when not hovering
      $(this).find('.product-sizes').fadeOut(200);
    }
  );
});